import type { ReviewSort } from '@repo/api-contracts';
import { useInfiniteQuery } from '@tanstack/react-query';
import { trpc } from '@/shared/api';
import { PRODUCT_REVIEWS_KEY } from './review-query-keys';

interface ProductReviewsQueryInput {
  readonly productId: string;
  readonly sort: ReviewSort;
  readonly photoOnly: boolean;
}

/**
 * 상품 후기 목록(reviews.listByProduct) — 커서 기반 무한 목록.
 * tRPC 의 useInfiniteQuery 는 입력에 direction 을 덧붙이는데 계약이 strict 라 거부된다 —
 * 그래서 TanStack useInfiniteQuery 에 tRPC 클라이언트 호출을 직접 물려 계약 그대로 보낸다.
 */
export const useProductReviewsQuery = ({
  productId,
  sort,
  photoOnly,
}: ProductReviewsQueryInput) => {
  const utils = trpc.useUtils();
  return useInfiniteQuery({
    queryKey: [PRODUCT_REVIEWS_KEY, productId, sort, photoOnly],
    queryFn: ({ pageParam }) =>
      utils.client.reviews.listByProduct.query({ productId, sort, photoOnly, cursor: pageParam }),
    initialPageParam: null as string | null,
    getNextPageParam: (page) => page.nextCursor,
  });
};
